import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { MatSelectChange, MAT_SELECT_CONFIG } from '@angular/material/select';

import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { optionContainsTerm } from '../../utils/util';

@Component({
    selector: 'combo-box',
    templateUrl: './combo-box.html',
    styleUrls: ['./combo-box.scss'],
    providers: [
        {
            provide: MAT_SELECT_CONFIG,
            useValue: { overlayPanelClass: 'select-overlay-panel' }
        }
    ],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-combo-box'
    }
})

export class ComboBox extends EnpsControl<string | number> implements OnInit {
    comboBoxFilter = new FormControl('');
    filteredOptions: Observable<{ id: string | number, title: string }[]>;
    filteredTimeZoneOptions: Observable<{ id: string, title: string }[]>;
    internalFormControl: FormControl<string | number> = new FormControl('');

    @Input() public itemList: { id: string | number, title: string }[] = [];
    @Input() public additionalItemList: { id: string, title: string }[] = [];
    @Input() public addEmptyOption: boolean;
    @Input() public emptyLabel: string;
    @Input() public addSeparatorAfterEmptyOption: boolean;
    @Input() public isNew: boolean = false;
    @Input() public shouldHaveFilter: boolean = true;

    ngOnInit() {
        this.filteredOptions = this.comboBoxFilter.valueChanges.pipe(
            startWith(''),
            takeUntil(this.destroyed$),
            map(value => this._filter(value || '')),
        );
        this.filteredTimeZoneOptions = this.comboBoxFilter.valueChanges.pipe(
            startWith(''),
            takeUntil(this.destroyed$),
            map(value => this._filterTimeZone(value || '')),
        );
    }

    private _filter(value: string): { id: string | number, title: string }[] {
        return this.itemList.filter(option => optionContainsTerm(option.id, value) || optionContainsTerm(option.title, value))
    }

    private _filterTimeZone(value: string): { id: string, title: string }[] {
        const filterValue = value.toLowerCase();
        return this.additionalItemList.filter(option => (option?.id.toLowerCase()?.includes(filterValue) || option?.title?.includes(filterValue)));
    }

    public async valueChanged(item: MatSelectChange) {
        if (this.value == ":empty:") {
            this.value = "";
        }
        this.changed.emit(this.value);
    }


    get isRTL() {
        return this.globalTablesService.getRtl();
    }

    get isRTLLikeString() : string {
        return String(this.globalTablesService.getRtl());
    }

    openedChanged(event: boolean) {
        super.onMenuOpened();
        if (!event) {
            this.comboBoxFilter.setValue('');
        }
    }

    _syncValueIfNecessary() {
        this.internalFormControl.setValue(this.value);
    }

    _addValidatorIfNecessary() {
        this.internalFormControl.addValidators(Validators.required);
        this.internalFormControl.markAllAsTouched();
    }

    _setDisabledState(isDisabled: boolean) {
        if (isDisabled) {
            this.internalFormControl.disable();
        } else {
            this.internalFormControl.enable();
        }
    }
}
